import React, { useEffect, useState} from 'react'
import { useHistory } from 'react-router-dom'
import api from '../components/api';
import { dataTableRender } from '../components/functions'


const Noticias = () => {

    var [resultado, setResultado] = useState('')
    var [na_codigo, setNaCodigo] = useState()
    var [resultadoCategorias, setResultadoCategorias] = useState()

    const history = useHistory();


    useEffect(() => {


        if (na_codigo) {

            history.push(`/Noticia/${na_codigo}`)

        }        

    }, [na_codigo])



    async function carregaCategorias() {


        await api.get('categoria').then((result) => {
            //console.log(result.data)

            setResultadoCategorias(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => history.push(`/Categoria/${rs.categoria_id}`)}>
                    <td>
                        {rs.descricao}
                    </td>
                </tr>
            
            ))


            dataTableRender('tabelaCategorias')


        }).catch((err) => {

            console.log(err.result)

        })

    }


    async function noticias() {

        //console.log('aqui')

        await api.get('noticias').then((result) => {
            //console.log(result.data)
            //console.log(result.data)


            setResultado(result.data.map((rs) => 

                <tr key={rs.na_codigo} style={{ cursor: 'pointer'}} onClick={() => setNaCodigo(rs.na_codigo)}>
                    <td>
                        {rs.dataISO}
                    </td>
                    <td>
                        {rs.na_titulo}
                    </td>
                    <td>
                        {rs.descricao}
                    </td>
                    
                    
                    
                    
                </tr>

            ))

            dataTableRender('tabelaNoticias')

    


        }).catch((err) => {
            console.log(err.response)
        })

    }



    async function verificaPermissao() {


        if (sessionStorage.getItem('permNoticias') != 'true') {

            history.push('/')

        }


    }


    useEffect(() => {

        
        verificaPermissao()
        noticias()
        carregaCategorias()

    }, [])


    return (

        <div>
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-pin'></i>
                </div>
                <div class='header-title'>
                    <h1>Notícias</h1>
                    <small>Administração</small>
                    
                </div>
            </div>


            <div className="row">

                <div class="col-md-12">

                    
                    <button type="button" onClick={() => history.push('/Noticia/Nova')} class="btn btn-info" >+ Nova Notícia</button>&nbsp;
                    <button type="button" class="btn btn-primary" >Destaque</button>
                    <br/><br/>

                </div>

                
                <ul className="nav nav-tabs">
                    <li className="active"><a href="#tab1" data-toggle="tab">Notícias</a></li>
                    <li ><a href="#tab2" data-toggle="tab" onClick={() => carregaCategorias()}>Categorias</a></li>
                    
                    
                </ul>
                        
                <div class="tab-content">
                    <div class="tab-pane fade in active" id="tab1">
                        <div class="panel-body">


                        
                                    
                            <div className="table-responsive">
                                <table id="tabelaNoticias" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '150px'}}>Data</th>
                                            <th>Título</th>
                                            <th>Categoria</th>
                                                                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultado}
                                    </tbody>
                                    
                                </table>
                            </div>
                                
                        


                        </div>
                    </div>
                    <div className="tab-pane fade in" id="tab2">
                        <div className="panel-body">

                        <div className="table-responsive">
                                <table id="tabelaCategorias" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                                                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultadoCategorias}
                                    </tbody>
                                    
                                </table>
                            </div>



                        </div>

                    </div>

                    
                </div>


                
            </div>
        
            

        </div>

    )

}

export default Noticias